module.exports = __webpack_public_path__ + "static/sui-button-floated-c4b550a5fd9cf71e8a27bbe03724048b.png";